<template>
  <div class="flex h-screen overflow-hidden">
    <SideBar :isOpen="isSidebarOpen" />

    <div class="flex-1 flex flex-col overflow-hidden">
      <NavBar @toggleSidebar="toggleSidebar" />

      <!-- Main Content Area -->
      <main class="flex-1 overflow-x-hidden overflow-y-auto bg-[#F1F1F1] mt-20 md:rounded-none md:mt-0">
        <router-view />
      </main>

      <!-- Footer -->
      <Footer />
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import SideBar from "@/components/SideBar";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";

const isSidebarOpen = ref(true);

const toggleSidebar = () => {
  isSidebarOpen.value = !isSidebarOpen.value;
};
</script>